export default __webpack_public_path__ + "static/media/CyberBot.7f14d2e9.jpg";